// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';
import { ParagraphMedium } from 'baseui/typography';

// ANCHOR Model
import { useRestrictedInfoDescription } from '@lyon/scoped-models/RestrictedInfo';

// ANCHOR Styles
import {
  BLOCK, TEXT, CENTER_BLOCK, CENTER_TEXT,
} from './styles';

interface IProps {
  isCenter?: boolean;
}

export const LyonRestrictedDescription = memo(({ isCenter }: IProps) => {
  const description = useRestrictedInfoDescription();

  return (
    <Block overrides={isCenter ? CENTER_BLOCK : BLOCK}>
      <ParagraphMedium overrides={isCenter ? CENTER_TEXT : TEXT}>
        {description}
      </ParagraphMedium>
    </Block>
  );
});
